import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import { removeStaticLoader } from "./components/App/utils";
import "./index.css";
import { loadScriptPromise } from "./utils/script";

loadScriptPromise(
  `https://${
    process.env.REACT_APP_JIGSAW_HOST
  }/assets/v1/jigsaw/box.js?v=${Date.now()}`
)
  .then(() => {
    // ok
  })
  .catch(e => {
    window.jigsawLoadError = true;
  })
  .then(() => {
    try {
      ReactDOM.render(<App />, document.getElementById("root"));
    } catch (e) {
      const root = document.getElementById("root");
      if (root) {
        root.innerHTML = "Oops! Something went wrong. Please try again later!";
      }
      removeStaticLoader();
    }
  });
